import axios from 'axios';

const API_BASE_URL = 'https://ptsspl.in/public/api';

export interface TaskEntry {
  id: number;
  user_id: number;
  department: string;
  task_type: string;
  quantity: number;
  custom_task: string | null;
  time_spent: number;
  created_at: string;
  updated_at: string;
}

class TaskEntryService {
  async getAll(): Promise<TaskEntry[]> {
    try {
      const response = await axios.get(`${API_BASE_URL}/task-entries`);
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch task entries');
    }
  }

  async getById(id: number): Promise<TaskEntry> {
    try {
      const response = await axios.get(`${API_BASE_URL}/task-entries/${id}`);
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch task entry');
    }
  }

  async create(entryData: Omit<TaskEntry, 'id' | 'created_at' | 'updated_at'>): Promise<TaskEntry> {
    try {
      const response = await axios.post(`${API_BASE_URL}/task-entries`, entryData);
      return response.data;
    } catch (error) {
      throw new Error('Failed to create task entry');
    }
  }

  async update(id: number, entryData: Partial<Omit<TaskEntry, 'id' | 'created_at' | 'updated_at'>>): Promise<TaskEntry> {
    try {
      const response = await axios.put(`${API_BASE_URL}/task-entries/${id}`, entryData);
      return response.data;
    } catch (error) {
      throw new Error('Failed to update task entry');
    }
  }

  async delete(id: number): Promise<void> {
    try {
      await axios.delete(`${API_BASE_URL}/task-entries/${id}`);
    } catch (error) {
      throw new Error('Failed to delete task entry');
    }
  }
}

const taskEntryService = new TaskEntryService();
export default taskEntryService;